module.exports = __webpack_public_path__ + "static/media/logo_en.2af7999e.png";


//////////////////
// WEBPACK FOOTER
// ./src/include/logo_en.png
// module id = 205
// module chunks = 0